(function() {
  const mediaContainer = document.querySelector('[data-furnace-media]');
  if (!mediaContainer) return;

  const video = mediaContainer.querySelector('.furnace-promo__video');
  const cover = mediaContainer.querySelector('.furnace-promo__cover');
  const playBtn = mediaContainer.querySelector('[data-furnace-play]');
  const playIcon = mediaContainer.querySelector('.furnace-promo__play-icon');
  const pauseIcon = mediaContainer.querySelector('.furnace-promo__pause-icon');

  if (!playBtn) return;

  pauseIcon.style.display = 'none';
  playIcon.style.display = 'block';

  playBtn.addEventListener('click', function() {
    if (!video) return;

    if (video.paused) {
      video.style.display = 'block';
      if (cover) cover.style.display = 'none';
      video.play();
      playBtn.style.display = 'none';
    } else {
      video.pause();
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      playBtn.style.display = 'block';
    }
  });

  if (video) {
    video.addEventListener('click', function() {
      if (!video.paused) {
        playBtn.style.display = 'block';
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
      }
    });

    video.addEventListener('ended', function() {
      if (cover) cover.style.display = 'block';
      video.style.display = 'none';
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      playBtn.style.display = 'block';
    });
  }

  const chatBtn = document.querySelector('[data-open-chat]');
  if (chatBtn) {
    chatBtn.addEventListener('click', function() {
      const liveChatIframe = document.querySelector('#chat-widget-minimized');
      if (!liveChatIframe) return;
      const liveChatBtn = liveChatIframe.contentDocument.querySelector("button[aria-label*='Open LiveChat']");
      liveChatBtn?.click();
    });
  }
})();
